import type { Step } from "react-joyride";

export type TGuidanceStage = "no_company" | "onboarding_in_progress" | "onboarding_complete" | "activated";

export type TTourStatus = "completed" | "dismissed";

export type TTourId =
  | "dashboard-welcome-v1"
  | "onboarding-questions-v1"
  | "sidebar-navigation-v1"
  | "chat-interface-v1";

export type TTooltipId = "sidebar-new-chat-v1" | "onboarding-optional-question-v1" | "dashboard-readiness-v1";

export type TBannerId = "onboarding-reminder-v1" | "next-step-chat-v1";

export type TGuidancePersistedState = {
  tours: Partial<Record<TTourId, TTourStatus>>;
  tooltips: Partial<Record<TTooltipId, boolean>>;
  banners: Partial<Record<TBannerId, boolean>>;
};

export type TTooltipTrigger = "firstVisit" | "firstInteraction" | "manual";

export type TGuidanceEventType = "tour" | "tooltip" | "banner";

export type TGuidanceEventAction = "started" | "completed" | "dismissed" | "shown";

export type TGuidanceEvent = {
  type: TGuidanceEventType;
  id: string;
  action: TGuidanceEventAction;
};

export type TTourDefinition = {
  id: TTourId;
  requiredStage: TGuidanceStage[];
  autoStart: "firstVisit" | "manual";
  routes: string[];
  steps: Step[];
};

export type TTooltipDefinition = {
  id: TTooltipId;
  requiredStage: TGuidanceStage[];
  trigger: TTooltipTrigger;
  title: string;
  content: string;
};

export type TBannerDefinition = {
  id: TBannerId;
  requiredStage: TGuidanceStage[];
  routes: string[];
  title: string;
  description: string;
  ctaLabel?: string;
  ctaRoute?: string;
};

export const EMPTY_GUIDANCE_STATE: TGuidancePersistedState = {
  tours: {},
  tooltips: {},
  banners: {},
};
